import { FC, useState } from 'react';

import { Box, Button, Dialog, Table, Tag, Text } from '@betterment/samba-react';

import { FirmBillingPlan, isTieredBillingRate } from '../../ClientBilling/BillingPlans/data';
import {
  formatAdvisoryFee,
  formatBillFrom,
  formatPlatformFeePaidBy,
  formatSharedPlatformFeeBreakdown,
} from '../../ClientBilling/BillingPlans/utils';
import ViewTieredRateModal from '../../ClientBilling/BillingPlans/view-tiered-rate-modal/ViewTieredRateModal';

export const SwitchBillingPlanTableRow: FC<{ billingPlan: FirmBillingPlan; effectivePlatformFee: number }> = ({
  billingPlan,
  effectivePlatformFee,
}) => {
  const [isTieredModalOpen, setIsTieredModalOpen] = useState<boolean>(false);

  return (
    <Table.Row>
      <Table.Cell>
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.100' }}>
          <Text>{billingPlan.name}</Text>
          {billingPlan.firmDefault && <Tag accent="blue">Firm default</Tag>}
        </Box>
        {billingPlan.latestChangeDescription && (
          <Text variant="text50" color="text.weak">
            {billingPlan.latestChangeDescription}
          </Text>
        )}
      </Table.Cell>
      <Table.Cell>
        {isTieredBillingRate(billingPlan.billingRate) ? (
          <Dialog open={isTieredModalOpen} onOpenChange={setIsTieredModalOpen} overlay="default">
            <Dialog.Trigger asChild={true}>
              <Button variant="textPrimary">Tiered</Button>
            </Dialog.Trigger>
            <ViewTieredRateModal
              plan={billingPlan}
              platformFee={effectivePlatformFee}
              onClose={() => setIsTieredModalOpen(false)}
            />
          </Dialog>
        ) : (
          <Text>{formatAdvisoryFee(billingPlan.billingRate)}</Text>
        )}
      </Table.Cell>
      <Table.Cell>{billingPlan.numberOfClients} clients</Table.Cell>
      <Table.Cell>{formatBillFrom(billingPlan.paymentType)}</Table.Cell>
      <Table.Cell>
        <Text>{formatPlatformFeePaidBy(billingPlan.platformFeeAllocation)}</Text>
        {billingPlan.platformFeeAllocation.__typename === 'SharedPlatformFeeAllocation' && (
          <Text variant="text50" color="text.weak" css={{ display: 'block' }}>
            {formatSharedPlatformFeeBreakdown(billingPlan.platformFeeAllocation, effectivePlatformFee)}
          </Text>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
